import React from 'react';
import { useTestAB } from '@catalogo/core-experiments';

export const withCardAds = Component => props => {
  const experiment = useTestAB('EXP_CAT_REC_ADS_CARD');

  return <Component {...props} experiment={experiment?.toLowerCase() === 'new' ? true : false} />;
};
